import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCustomerPortalSession } from "../constants/auth";

const CustomerPortalGuard = ({ children }) => {
  const location = useLocation();
  const session = getCustomerPortalSession();

  if (!session) {
    return <Navigate to="/customer-portal/login" replace state={{ from: location }} />;
  }

  return children;
};

export default CustomerPortalGuard;
